import React, { useContext } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import Configuration from "../configurationMenu";

import { Account } from "../account";
import { Home } from "../components/home/home";
import { RouterContext } from "../globalContext";
import TrendingsIndex from "../pages/trendings/index";

const MESFMainRouter = () => {
	const CustomRoutes: any = useContext(RouterContext);

	return (
		<>
			<Routes>
				<Route path="/" element={<Navigate replace to="/home" />} />
				<Route path="/configuration/*" element={<Configuration />} />
				<Route path="/account" element={<Account />} />
				<Route path="/trendings" element={<TrendingsIndex />} />
				<Route path="/home" element={<Home />} />
			</Routes>
			<CustomRoutes />
		</>
	);
};
export default MESFMainRouter;
